<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapState, mapActions } from "vuex";

import InputGroup from "@/components/_Shared/InputGroup";

export default {
  components: {
    swiper,
    swiperSlide,
    InputGroup
  },

  props: {
    title: {
      type: String,
      required: false
    },
    searchInput: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  data() {
    return {
      swiperOption: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 0,
        centerInsufficientSlides: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        breakpoints: {
          530: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            centeredSlides: true
          },
          730: {
            slidesPerView: 2,
            slidesPerGroup: 2
          }
        }
      },
      search: "",
      filtered_professionals: []
    };
  },

  computed: {
    ...mapState("newOrder", ["professionals_available"]),

    professional_selected() {
      return this.$store.state.newOrder.professional;
    }
  },

  methods: {
    ...mapActions("newOrder", ["setProfessional"]),

    filter_professionals() {
      this.setProfessional(null);
      let regex = new RegExp(this.search, "i");

      this.filtered_professionals = this.professionals_available.filter(
        professional => {
          return (
            regex.test(professional.account.first_name) ||
            regex.test(professional.account.last_name)
          );
        }
      );
    },

    selectProfessional(professional) {
      this.setProfessional(professional);
      this.$emit("professionalSelected");
    }
  },

  watch: {
    professionals_available(professionals) {
      this.filter_professionals();
    }
  },

  filters: {
    fullName(account) {
      return account.first_name + " " + account.last_name;
    },
    completedOrdersCount(num) {
      return num < 5 ? "< 5" : num;
    }
  },

  mounted() {
    this.filter_professionals();
  }
};
</script>

<template>
  <div
    id="professionals"
    class="section"
    v-if="!professionals_available.length"
  >
    Não há profissionais disponíveis no dia e período escolhido.
  </div>

  <div id="professionals" class="section" v-else>
    <div v-if="title" class="section-title">
      {{ title }}
      <hr />
    </div>

    <div v-if="searchInput" class="search">
      <InputGroup
        v-model="search"
        label="busque pelo nome"
        @keyup="filter_professionals"
      />
    </div>

    <div class="section-body">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide
          v-for="professional in filtered_professionals"
          :key="professional.id"
        >
          <div
            class="professional"
            :class="{
              checked:
                professional_selected &&
                professional_selected.id === professional.id
            }"
            @click="selectProfessional(professional)"
          >
            <img :src="professional.account.profile.profile_picture" />
            <div class="hovered">
              <div class="icon-check"></div>
            </div>
            <p>
              {{ professional.account | fullName }}
            </p>
            <small
              >{{
                professional.completed_orders_count | completedOrdersCount
              }}
              limpezas</small
            >

            <div class="bg-rating">
              <div
                class="stars"
                :style="'width: ' + professional.rating / 100 + '%'"
              ></div>
            </div>
          </div>
        </swiper-slide>

        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
  </div>
</template>

<style scoped>
.bg-rating {
  background: url("https://res.cloudinary.com/joaofnds/image/upload/v1548201143/email%20donamaid/estrela_contorno-01.png")
    no-repeat;
  width: 69px;
  height: 11px;
}

.stars {
  background: url("https://res.cloudinary.com/joaofnds/image/upload/v1548201143/email%20donamaid/estrela_color-01.png")
    no-repeat;
  max-width: 69px;
  height: 11px;
}

.swiper-container {
  width: 100%;
  text-align: center;
}

.section-body {
  width: 600px;
  max-width: 600px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.professional {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 20px;
  user-select: none;
  cursor: pointer;
}

.professional:first-child {
  margin-left: 0;
}

.professional:last-child {
  margin-right: 0;
}

.professional p {
  margin: 10px 0 5px 0;
}

.professional small {
  font-size: 12px;
}

.professional img:first-child {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border: 4px solid #f1f1f1f1;
  border-radius: 100%;
}

.professional .hovered {
  opacity: 0;
  width: 120px;
  height: 120px;
  margin-top: -124px;
  border-radius: 100%;
  background: linear-gradient(
    45deg,
    rgba(204, 204, 204, 0.8) 0%,
    rgba(204, 204, 204, 0.3) 100%
  );
  z-index: 99;
  transition: all 0.25s ease;
}

.professional .hovered .icon-check {
  background: url("/static/icon-check.svg") no-repeat center;
  background-size: 25px;
  width: 100%;
  height: 100%;
}

.professional.checked .hovered {
  opacity: 1;
  background: linear-gradient(
    45deg,
    rgba(96, 50, 133, 0.8) 0%,
    rgba(175, 0, 107, 0.8) 100%
  );
}

.professional:hover .hovered {
  opacity: 1;
}

.professional img:last-child {
  height: 12px;
  object-fit: cover;
}

.swiper-button-prev {
  background-image: url("/static/arrow-prev.svg");
}

.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  left: 0 !important;
}

.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  right: 0 !important;
}

.swiper-button-next {
  background-image: url("/static/arrow-next.svg");
}

@media (max-width: 720px) {
  .section-body {
    width: 400px;
  }
}

@media (max-width: 630px) {
  .section-body {
    width: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Steps/Professionals.vue